import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {merchants_api, permission_api, sidePermission_api} from "../PackMan/PackManService";
import "../PackMan/PackMan.scss"
import {Setup} from "../../Services";

function Merchants() {

    const history = useHistory()

    //states
    const [merchants,set_merchants] = useState([])

    const getMerchants = async ()=>{
        try {
            const resp = await merchants_api();
            set_merchants(resp.data)
        }catch (e) {
            console.log(e)
        }
    }

    const [perm,set_perm]= useState([]);

    useEffect(()=>{
        getMerchants()

    },[])

    const setMerchantToApp =  (id)=>{
        localStorage.setItem('merchantId',id);
        getPermission(id)

    }


    const getPermission = async (i)=>{
        try{
            const res = await sidePermission_api(i)
            set_perm(res.data)
            let role = res.data
            let result = "/merchants"

            if(role.find(o => o.id === 12))
                result = "/peyk"

            if(role.find(o => o.id === 11))
                result = "/pack-man"

            if(role.find(o => o.id === 9))
                result = "/send-management"


            history.push(result)
        }catch (e) {
            console.log(e)
        }
    }

    const MerchantCard= ({item})=>{
        return(
            <div className="merchant-item" onClick={()=>setMerchantToApp(item.uid)}>
                <img src={item.image?item.image:"/other/skeleton/slide.jpg"} alt=""/>
                <span className="merchant-name">{item.name}</span>
                <span className="merchant-role">{item.role} <i className="fa fa-user"></i></span>
            </div>
        )
    }

    return(
        <div className="merchant-container">
            <h4>انتخاب مرچنت</h4>
            <div className="merchant-list">
                {/*<span onClick={()=>history.push('/pack-man')}>home</span>*/}
                {merchants.map(merchant=>{
                    return(
                        <MerchantCard item={merchant} />
                    )
                })}
            </div>
        </div>
    )

}

export default Merchants;
